import React, { Fragment, PureComponent } from 'react';
import Link from 'next/link';
import CategoryList from '../CategoryList';
import BottomMenu from '../BottomMenu';
import Footer from '../Footer';
import AboutPages from './AboutPages';
import AwardsPages from './AwardsPages';
import ContactPage from './ContactPage';
import VideoList from '../Videos/VideoList';
import { categoryApi } from '../../apis/CategoryApi';
import MbSidebarMenu from '../MbSidebarMenu';
import MbVideoList from '../Mobile/MbVideoList';
import { localeFunction } from '../../locales/functions';
import ChangeLanguage from '../ChangeLanguage';

class SinglePage extends PureComponent {
   state = {
      categories: [],
   }

   async componentDidMount() {
      const categories = await categoryApi.getCategoryList();
      this.setState({ categories });
   }

   getPageLabel = (pageName) => {
      if (pageName === 'about') {
         return localeFunction.locale.about;
      } else if (pageName === 'awards') {
         return localeFunction.locale.awards;
      } else if (pageName === 'contact') {
         return localeFunction.locale.contact;
      } else if (pageName === 'video') {
         return localeFunction.locale.video;
      }
      return '';
   }

   render() {
      const { isMobileView } = this.props;
      return (
         <Fragment>
            <div className="main-header">
               {
                  isMobileView &&
                  <MbSidebarMenu isMobileView={isMobileView} />
               }
               <Link href="/">
                  <a className="header-logo">DNAP ARCHITECTURE</a>
               </Link>
               <ChangeLanguage />
            </div>
            {
               !isMobileView &&
               <CategoryList
                  categories={this.state.categories}
                  deActive
               />
            }
            {
               isMobileView &&
               <labe className="page-label">{this.getPageLabel(this.props.pageName)}</labe>
            }
            {
               this.props.pageName === 'about' &&
               <AboutPages isMobileView={isMobileView} />
            }
            {
               this.props.pageName === 'awards' &&
               <AwardsPages />
            }
            {
               this.props.pageName === 'contact' &&
               <ContactPage />
            }
            {
               this.props.pageName === 'video' &&
               <Fragment>
                  {
                     !isMobileView ?
                        <VideoList />
                        :
                        <MbVideoList />
                  }
               </Fragment>
            }
            {
               !isMobileView &&
               <BottomMenu />
            }
            <Footer />
         </Fragment>
      );
   }
}

export default SinglePage;